import { useMemo } from "react";
import { observer } from "mobx-react";
import { getProfitColor } from "@utils";
import { useEstimateStructure, ValueCell } from "@tools";
import { useTheme } from "@material-ui/core/styles";

export const FixedCompanyProfitabilityCell = observer((cellProps) => {
  const theme = useTheme();
  const structure = useEstimateStructure();
  const { companyBreakdownFixedProfitability } = structure;
  
  const notApplicable = useMemo(() => (
    companyBreakdownFixedProfitability === null
  ), [companyBreakdownFixedProfitability]);
  
  const color = useMemo(() => (
    getProfitColor(companyBreakdownFixedProfitability, theme)
  ), [companyBreakdownFixedProfitability, theme]);
  
  return <ValueCell
    size="medium"
    displayContent
    emptyValue={notApplicable} //@todo: check
    value={companyBreakdownFixedProfitability}
    symbolEnd="%"
    max={99.99}
    style={{color}}
    {...cellProps}
  />
})